import m from "./index54.js";
import c from "./index46.js";
import l from "./index47.js";
import { DIRECTION as p } from "./index125.js";
import d from "./index127.js";
import "./index48.js";
import "./index30.js";
import "./index55.js";
import "./index58.js";
class r extends m {
  constructor(e) {
    super({
      ...r.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      enum: t,
      ...s
    } = e;
    if (t) {
      const i = t.map((h) => h.length), a = Math.min(...i), n = Math.max(...i) - a;
      s.mask = "*".repeat(a), n && (s.mask += "[" + "*".repeat(n) + "]"), this.enum = t;
    }
    super._update(s);
  }
  _appendCharRaw(e, t) {
    t === void 0 && (t = {});
    const s = Math.min(this.nearestInputPos(0, p.FORCE_RIGHT), this.value.length), i = this.enum.filter((a) => this.matchValue(a, this.unmaskedValue + e, s));
    if (i.length) {
      i.length === 1 && this._forEachBlocksInRange(0, this.value.length, (n, h) => {
        const u = i[0][h];
        h >= this.value.length || u === n.value || (n.reset(), n._appendChar(u, t));
      });
      const a = super._appendCharRaw(i[0][this.value.length], t);
      return i.length === 1 && i[0].slice(this.unmaskedValue.length).split("").forEach((n) => a.aggregate(super._appendCharRaw(n))), a;
    }
    return new l({
      skip: !this.isComplete
    });
  }
  extractTail(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), new d("", e);
  }
  remove(e, t) {
    if (e === void 0 && (e = 0), t === void 0 && (t = this.displayValue.length), e === t)
      return new l();
    const s = Math.min(super.nearestInputPos(0, p.FORCE_RIGHT), this.value.length);
    let i;
    for (i = e; i >= 0 && !(this.enum.filter((h) => this.matchValue(h, this.value.slice(s, i), s)).length > 1); --i)
      ;
    const a = super.remove(i, t);
    return a.tailShift += i - e, a;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
r.DEFAULTS = {
  ...m.DEFAULTS,
  matchValue: (o, e, t) => o.indexOf(e, t) === t
};
c.MaskedEnum = r;
export {
  r as default
};
